// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-old {
    display: none;
}

/* Variables */
#authentication.user-coordinator {
    --form-width: 100%;
    --card-padding: 20px;
    --form-wrapper-h-padding: 30px;
}
@media (min-width: 576px) {
    #authentication.user-coordinator {
        --form-width: 360px;
        --card-padding: 30px;
        --form-wrapper-h-padding: 50px;
    }
}
@media (min-width: 768px) {
    #authentication.user-coordinator {
        --form-width: 320px;
    }
}
@media (min-width: 992px) {
    #authentication.user-coordinator {
        --form-width: 360px;
    }
}

/* Typography */
#authentication.user-coordinator {
    font-size: 16px;
    line-height: var(--default_line_height);
}
h2 {
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 0;
    line-height: 1.2;
    margin-bottom: 3px;
}
h3 {
    font-size: 20px;
    color: var(--lightest_legible_grey);
    font-weight: 500;
    /* line-height: 1.25; */
}
ol,
ul {
    list-style: disc;
    padding-left: 1.25em;
}
p,
li {
    padding: 4px 0;
}
.small-print,
.small-print a {
    font-size: 14px;
    color: var(--lightest_legible_grey);
}

/* page layout */

html {
    overflow: hidden;
}

.authentication-action {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 50%;
    padding: calc(var(--card-padding) + var(--lg_padding)) var(--card-padding);
}
#authentication.user-coordinator {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
}
main {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: var(--ce-com-gradient);
}
@media (min-width: 768px) {
    #authentication.user-coordinator {
        height: 100dvh;
    }
}

/* form body */
.form-wrapper {
    padding: 35px var(--form-wrapper-h-padding) 40px var(--form-wrapper-h-padding);
    background: var(--ce-grey-1);
    width: 100%;
    flex: 1;
}
@media (min-width: 576px) {
    .form-wrapper {
        width: auto;
        margin-top: 50px;
        border-radius: var(--border_radius_lg);
        flex: initial;
    }
}
.user-coordinator .form {
    margin: 0 auto;
    width: var(--form-width);
    display: flex;
    flex-direction: column;
    row-gap: var(--md_padding);
    align-items: stretch;
    max-width: 100%;
}

.form-header {
    text-align: center;
    margin-bottom: var(--sm_padding);
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-header-logo {
  margin-bottom: 20px;
  max-width: 150px;
}

/* Form elements */
input,
button,
.rk-admin .admin-input,
.rk-admin .editor-controls-button {
    height: var(--ideal_touch_target);
    min-height: var(--ideal_touch_target);
    min-width: var(--ideal_touch_target);
    font-size: 16px;
}
.rk-admin .editor-controls-button {
    font-weight: 500;
}
.field-group {
    display: flex;
    flex-direction: column;
}
.field-group label {
    font-weight: 500;
    padding-bottom: 3px;
}
.rk-admin .combo-input-group .admin-input {
    flex: 1;
}
.editor-controls-button.text-button {
    background: transparent;
    border: 0;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    color: var(--blue);
}
.editor-controls-button.text-button:hover,
.editor-controls-button.text-button:hover:enabled {
    color: var(--ce-blue-70);
    background: transparent;
}
.editor-controls-button.text-button .plain-text {
    color: var(--lightest_legible_grey);
}
.editor-controls-button.tertiary-button {
    background: var(--ce-grey-4);
    color: var(--ce-blue-50);
    border: 0;
    text-decoration: none;
    font-weight: 500;
    align-items: center;
    display: flex;
}

/* Errors */

.server-error {
    color: var(--ce-red-55);
    background: var(--ce-red-2);
    border: 1px solid var(--ce-red-10);
    border-radius: var(--border_radius);
    padding: 8px 12px;
}

.client-error-container {
    background: var(--ce-violet-2);
    border: 1px solid var(--ce-violet-10);
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border-radius: var(--border_radius);
}

`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/authentication.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;AAClC;AACA;IACI;QACI,mBAAmB;QACnB,oBAAoB;QACpB,8BAA8B;IAClC;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,eAAe;AACf;IACI,eAAe;IACf,uCAAuC;AAC3C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;IAEI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,eAAe;IACf,mCAAmC;AACvC;;AAEA,gBAAgB;;AAEhB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,0EAA0E;AAC9E;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,cAAc;AACd;IACI,8EAA8E;IAC9E,4BAA4B;IAC5B,WAAW;IACX,OAAO;AACX;AACA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,sCAAsC;QACtC,aAAa;IACjB;AACJ;AACA;IACI,cAAc;IACd,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;;;;IAII,iCAAiC;IACjC,qCAAqC;IACrC,oCAAoC;IACpC,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,OAAO;AACX;AACA;IACI,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,WAAW;;AAEX;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mCAAmC;AACvC","sourcesContent":[".login-old {\n    display: none;\n}\n\n/* Variables */\n#authentication.user-coordinator {\n    --form-width: 100%;\n    --card-padding: 20px;\n    --form-wrapper-h-padding: 30px;\n}\n@media (min-width: 576px) {\n    #authentication.user-coordinator {\n        --form-width: 360px;\n        --card-padding: 30px;\n        --form-wrapper-h-padding: 50px;\n    }\n}\n@media (min-width: 768px) {\n    #authentication.user-coordinator {\n        --form-width: 320px;\n    }\n}\n@media (min-width: 992px) {\n    #authentication.user-coordinator {\n        --form-width: 360px;\n    }\n}\n\n/* Typography */\n#authentication.user-coordinator {\n    font-size: 16px;\n    line-height: var(--default_line_height);\n}\nh2 {\n    font-size: 30px;\n    font-weight: 600;\n    padding-bottom: 0;\n    line-height: 1.2;\n    margin-bottom: 3px;\n}\nh3 {\n    font-size: 20px;\n    color: var(--lightest_legible_grey);\n    font-weight: 500;\n    /* line-height: 1.25; */\n}\nol,\nul {\n    list-style: disc;\n    padding-left: 1.25em;\n}\np,\nli {\n    padding: 4px 0;\n}\n.small-print,\n.small-print a {\n    font-size: 14px;\n    color: var(--lightest_legible_grey);\n}\n\n/* page layout */\n\nhtml {\n    overflow: hidden;\n}\n\n.authentication-action {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 50%;\n    padding: calc(var(--card-padding) + var(--lg_padding)) var(--card-padding);\n}\n#authentication.user-coordinator {\n    display: flex;\n    flex-direction: column;\n    min-height: 100dvh;\n}\nmain {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  background: var(--ce-com-gradient);\n}\n@media (min-width: 768px) {\n    #authentication.user-coordinator {\n        height: 100dvh;\n    }\n}\n\n/* form body */\n.form-wrapper {\n    padding: 35px var(--form-wrapper-h-padding) 40px var(--form-wrapper-h-padding);\n    background: var(--ce-grey-1);\n    width: 100%;\n    flex: 1;\n}\n@media (min-width: 576px) {\n    .form-wrapper {\n        width: auto;\n        margin-top: 50px;\n        border-radius: var(--border_radius_lg);\n        flex: initial;\n    }\n}\n.user-coordinator .form {\n    margin: 0 auto;\n    width: var(--form-width);\n    display: flex;\n    flex-direction: column;\n    row-gap: var(--md_padding);\n    align-items: stretch;\n    max-width: 100%;\n}\n\n.form-header {\n    text-align: center;\n    margin-bottom: var(--sm_padding);\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.form-header-logo {\n  margin-bottom: 20px;\n  max-width: 150px;\n}\n\n/* Form elements */\ninput,\nbutton,\n.rk-admin .admin-input,\n.rk-admin .editor-controls-button {\n    height: var(--ideal_touch_target);\n    min-height: var(--ideal_touch_target);\n    min-width: var(--ideal_touch_target);\n    font-size: 16px;\n}\n.rk-admin .editor-controls-button {\n    font-weight: 500;\n}\n.field-group {\n    display: flex;\n    flex-direction: column;\n}\n.field-group label {\n    font-weight: 500;\n    padding-bottom: 3px;\n}\n.rk-admin .combo-input-group .admin-input {\n    flex: 1;\n}\n.editor-controls-button.text-button {\n    background: transparent;\n    border: 0;\n    text-decoration: none;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    color: var(--blue);\n}\n.editor-controls-button.text-button:hover,\n.editor-controls-button.text-button:hover:enabled {\n    color: var(--ce-blue-70);\n    background: transparent;\n}\n.editor-controls-button.text-button .plain-text {\n    color: var(--lightest_legible_grey);\n}\n.editor-controls-button.tertiary-button {\n    background: var(--ce-grey-4);\n    color: var(--ce-blue-50);\n    border: 0;\n    text-decoration: none;\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n}\n\n/* Errors */\n\n.server-error {\n    color: var(--ce-red-55);\n    background: var(--ce-red-2);\n    border: 1px solid var(--ce-red-10);\n    border-radius: var(--border_radius);\n    padding: 8px 12px;\n}\n\n.client-error-container {\n    background: var(--ce-violet-2);\n    border: 1px solid var(--ce-violet-10);\n    margin-bottom: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px;\n    border-radius: var(--border_radius);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
